/**
 * getTerminalDisplayLabel utility.
 * Returns a formatted terminal label based on the display type.
 *
 * @param {object} options - displayType, defaultLabel, trip, tripWay.
 * @param {string} [options.displayType='default'] - Display format: 'city_terminal' or 'default'.
 * @param {string} options.defaultLabel - Fallback label when displayType is 'default'.
 * @param {object} options.trip - Immutable trip data object.
 * @param {string} options.tripWay - Key to access the trip direction (e.g. 'origin' or 'destination').
 * @returns {string} Formatted terminal label.
 */
const getTerminalDisplayLabel = (options = {}) => {
  const { displayType = 'default', defaultLabel = '', trip, tripWay } = options;

  switch (displayType) {
    case 'city_terminal': {
      const city = trip.getIn([tripWay, 'cityName']) || defaultLabel;
      const terminal = trip.getIn([tripWay, 'name']) || defaultLabel;

      if (!(terminal && city)) {
        return defaultLabel;
      }

      return `${city}, ${terminal}`;
    }
    case 'default':
      return defaultLabel;
    default:
      return defaultLabel;
  }
};

export default getTerminalDisplayLabel;
